// extracted by mini-css-extract-plugin
export default {"container":"IFrame_container__SdDd0"};